import { BearerTokenGetterContext } from '@pelckmans/business-components/context/BearerTokenGetterContext';
import { ReviewDialog } from '@pelckmans/business-components/components/exercise-manager';
import { useTranslation } from 'react-i18next';
import getAccessToken from '../../../api/BearerToken';
import { useContext } from 'react';
import ModalContext from '../../../contexts/ModalContext';
import { EduhintMedialink, EdumaticMedialink } from '../_api/MedialinksApi';
import { Module } from '../_api/ModuleApi';

type ReviewModalProps = {
  id: string;
  medialink: EdumaticMedialink | EduhintMedialink;
  sessionId: string;
  module: Module;
};

export default function ReviewModal({ id, medialink, sessionId, module }: ReviewModalProps) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function onClose() {
    closeModal(id);
  }

  return (
    <BearerTokenGetterContext.Provider value={getAccessToken}>
      <ReviewDialog
        medialink={medialink}
        sessionId={sessionId}
        superModuleHasExerciseEntrance={module.hasExerciseEntrance}
        onClose={onClose}
        translations={{
          closeDialog: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.CLOSE_DIALOG'),
          loading: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.LOADING'),
          generalNode: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.GENERAL_NODE'),
          serviceNotAvailable: {
            title: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.TITLE'),
            p1: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P1'),
            p2: t('BUSINESS_COMPONENTS.EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P2'),
          },
        }}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
      />
    </BearerTokenGetterContext.Provider>
  );
}
